import React, { useEffect, useState } from "react";
import { Box, Flex, Spinner, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import GButton from "components/ui/button/Button";
import AppliesOnCombosModal from "./modals/AppliesOnCombosModal";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getDiscountsCombos } from "features/management/discounts/services/discountsCombosService";
import CombosTable from "./CombosTable";
import DeleteAppliesModal from "./modals/DeleteAppliesModal";

const AppliesOnCombos = () => {
  const id = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [showCombosOfDiscounts, setShowCombosOfDiscounts] = useState(false);
  const [showDeleteProductModal, setShowDeleteProductModal] = useState(null);

  const combos = useSelector((state) => state.discountsCombos);

  useEffect(() => {
    dispatch(getDiscountsCombos(id.id));
  }, [dispatch, id]);

  return (
    <Box>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        gap={2}
        flexWrap="wrap"
        mb={6}
      >
        <Text color="text" textTransform="capitalize">
          {t("pages.discounts.applies_on_combos")}
        </Text>

        <GButton
          title={t("pages.discounts.add_combos")}
          bg="light"
          color="text"
          fontSize="14px"
          border="1px solid"
          borderColor="border"
          hover={{ bg: "light" }}
          onClick={() => setShowCombosOfDiscounts(true)}
        />
      </Flex>

      {combos.isLoading ? (
        <Spinner />
      ) : combos.data?.length === 0 ? (
        <Flex
          p={4}
          bg="white"
          alignItems="center"
          justifyContent="center"
          color="text"
          textTransform="capitalize"
          boxShadow="0rem 0.3125rem 0.3125rem 0rem rgba(82, 63, 105, 0.05)"
          borderRadius={6}
        >
          {t("pages.branches.no_data")}
        </Flex>
      ) : combos.data?.length > 0 ? (
        <CombosTable
          combosOfDiscounts={combos.data}
          handleDelete={(combo) => setShowDeleteProductModal(combo)}
        />
      ) : (
        <Flex
          p={4}
          bg="white"
          alignItems="center"
          justifyContent="center"
          color="text"
          textTransform="capitalize"
          boxShadow="0rem 0.3125rem 0.3125rem 0rem rgba(82, 63, 105, 0.05)"
          borderRadius={6}
        >
          {t("pages.branches.no_data")}
        </Flex>
      )}

      {showCombosOfDiscounts && (
        <AppliesOnCombosModal onClose={() => setShowCombosOfDiscounts(false)} />
      )}
      {showDeleteProductModal && (
        <DeleteAppliesModal
          id={showDeleteProductModal}
          onClose={() => setShowDeleteProductModal(null)}
          type="Combo"
        />
      )}
    </Box>
  );
};

export default AppliesOnCombos;
